import React, { Component } from 'react';
import AsyncSelect from 'react-select/async';
import Swal from 'sweetalert2';
import { getGetRequestOptions } from "../components/GetToken";
import { AppContext } from '../context/AppContext';
import Select, { components } from 'react-select';
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import SVG from "react-inlinesvg";

const UserSingleValue = ({ children, ...props }) => (
    <components.SingleValue {...props}>
        <span>{props.data.employeeName}</span>
    </components.SingleValue>
)

class EquipmentSiteEngineerAssign extends Component {
    static contextType = AppContext;
    state = {
        businessUnit: process.env.REACT_APP_EMD_BU_ID,
        equipment: "",
        project: "",
        projectInCharge: "",
        siteEngineer: "",
        remarks: "",
        assignDate: "",
        allBusinessUnits: [],
    }

    componentDidMount() {
        const { ...baseState } = this.state;
        this.baseState = baseState;
        this.getAllBu();
    }

    getAssignedEquipment = (inputValue, callback) => {

        if (!inputValue) {
            callback([]);

        } else {
            var url = process.env.REACT_APP_API_URL + "equipment/assigned_equipment_search?q=" + inputValue;
            setTimeout(() => {
                fetch(url,
                    getGetRequestOptions())
                    .then((resp) => {
                        return resp.json()
                    })
                    .then((resp) => {
                        const tempArray = resp.data.map(function (element) {
                            element.label = `${element.equipmentName} (${element.equipmentCode})`;
                            element.value = element.equipmentId;
                            return element;
                        });
                        callback(tempArray);
                    })
                    .catch((error) => {
                        console.log(error, "catch the hoop")
                    });
            });
        }
    }

    getAllBu() {
        fetch(process.env.REACT_APP_API_URL + "get_business_units",
            getGetRequestOptions())
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let tempResp = resp.data.map(function (element) {
                    return { ...element, label: element.projectName, value: element.projectId }
                });
                this.setState({ allBusinessUnits: tempResp });
            })
            .catch((error) => {
                console.log(error, "catch the hoop")
            });

    }

    getAllProjectInCharge(buId, inputValue, callback) {
        if (!inputValue) {
            callback([]);

        } else {
            var api = process.env.REACT_APP_API_URL + "users/project_in_charge?q=" + inputValue + "&bu=" + buId;
            setTimeout(() => {
                fetch(api, getGetRequestOptions())
                    .then((resp) => {
                        return resp.json()
                    })
                    .then((resp) => {
                        const tempArray = resp.data.map(function (element) {
                            return { ...element, id: element.employeeId, label: element.employeeName, value: element.employeeId }
                        });

                        callback(tempArray);
                    })
                    .catch((error) => {
                        console.log(error, "catch the hoop")
                    });
            });
        }
    }

    getAllSiteEngineer(buId, inputValue, callback) {
        if (!inputValue) {
            callback([]);

        } else {
            var api = process.env.REACT_APP_API_URL + "users/site_engineer?q=" + inputValue + "&bu=" + buId;

            setTimeout(() => {
                fetch(api, getGetRequestOptions())
                    .then((resp) => {
                        return resp.json()
                    })
                    .then((resp) => {
                        const tempArray = resp.data.map(function (element) {
                            return { ...element, id: element.employeeId, label: element.employeeName, value: element.employeeId }
                        });

                        callback(tempArray);
                    })
                    .catch((error) => {
                        console.log(error, "catch the hoop")
                    });
            });
        }
    }

    handleEquipmentChange = item => {
        if (item.currentProjectId !== null) {
            var project = { projectId: item.currentProjectId, label: item.currentProject, value: item.currentProjectId, projectName: item.currentProject };
        }
        if (item.projectInChargeId !== null) {
            var projectInCharge = { id: item.projectInChargeId, label: item.projectInChargeName, value: item.projectInChargeId, employeeId: item.projectInChargeId, employeeName: item.projectInChargeName, avatar: item.projectInChargeAvatar, designationTitle: item.projectInChargeDesignationTitle, workStationName: item.projectInChargeWorkStationName, inChargeBusinessUnitId: item.currentProjectId };
        }
        if (item.siteEngId !== null) {
            var siteEngineer = { id: item.siteEngId, label: item.siteEngName, value: item.siteEngId, employeeId: item.siteEngId, employeeName: item.siteEngName, avatar: item.siteEngAvatar, designationTitle: item.siteEngDesignationTitle, workStationName: item.siteEngWorkStationName };
        }
        this.setState({
            equipment: {
                equipmentId: item.equipmentId,
                equipmentName: item.equipmentName,
                equipmentCode: item.equipmentCode,
                label: item.equipmentName + " (" + item.equipmentCode + ")",
                value: item.equipmentId
            }, project: project, projectInCharge: projectInCharge, siteEngineer: siteEngineer
        });
    }

    handleProjectChange = project => {
        this.setState({ project: project, projectInCharge: "", siteEngineer: "" });
    }

    handleProjectInChargeChange = projectInCharge => {
        this.setState({ projectInCharge: projectInCharge, siteEngineer: "" });
    }

    handleSiteEngineerChange = siteEngineer => {
        this.setState({ siteEngineer: siteEngineer });
    }

    handleInputOnChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleSubmit = evt => {
        evt.preventDefault();
        const isValid = true
        if (isValid) {
            Swal.fire({
                title: 'Are you sure?',
                text: "You want to assign this equipment",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            }).then((result) => {
                if (result.value) {
                    const jwt = this.context.jwt.token;
                    const formData = {
                        businessUnit: process.env.REACT_APP_EMD_BU_ID,
                        equipment: this.state.equipment,
                        project: this.state.project,
                        projectInCharge: this.state.projectInCharge,
                        siteEngineer: this.state.siteEngineer,
                        remarks: this.state.remarks,
                        assignDate: this.state.assignDate
                    };
                    const requestOptions = {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwt },
                        body: JSON.stringify(formData)
                    };

                    var apiEnd = "equipment/assign_site_engineer";

                    fetch(process.env.REACT_APP_API_URL + apiEnd, requestOptions)
                        .then((resp) => {
                            return resp.json()
                        })
                        .then((resp) => {
                            console.log(resp);

                            if (resp.success === true) {
                                let successMsg = resp.successMessage;
                                Swal.fire({
                                    icon: 'success',
                                    title: 'Success',
                                    text: successMsg,
                                })

                                this.setState({
                                    equipment: "",
                                    project: "",
                                    projectInCharge: "",
                                    siteEngineer: "",
                                    remarks: "",
                                    assignDate: ""
                                });

                            }
                            else {
                                //var errorsMessage = "";
                                var errorsMessage = [];

                                if (resp.errorMessage !== undefined && typeof resp.errorMessage === 'object') {
                                    var errorsObj = resp.errorMessage;
                                    Object.keys(errorsObj).forEach(function (value) {
                                        errorsObj[value].forEach(function (v) {
                                            //errorsMessage.push(v)
                                            errorsMessage += '<div>' + v + '</div>';
                                        });

                                    });

                                } else if (resp.errorMessage !== undefined && (typeof resp.errorMessage === 'string' || resp.errorMessage instanceof String)) {
                                    //errorsMessage = resp.errorMessage;
                                    errorsMessage.push(resp.errorMessage);
                                } else {
                                    //errorsMessage = "Something went wrong";
                                    errorsMessage.push("Something went wrong");
                                }
                                //console.log(errorsMessage);
                                Swal.fire({
                                    icon: 'error',
                                    title: resp.heading,
                                    html: errorsMessage
                                })
                            }


                        })
                        .catch((error) => {
                            console.log(error, "catch the hoop")
                        });
                }
            })
        }
    }


    render() {

        return (
            <>
                <div className="card card-custom">
                    <div className="card-header">
                        <h3 className="card-title">
                            <p className="text-primary">
                                Site Engineer Assign
                            </p>
                        </h3>
                    </div>

                    <form onSubmit={this.handleSubmit}>
                        <div className="card-body">
                            <div className="ml-12">
                                <div className="form-group row">
                                    <label htmlFor="equipment" className="col-lg-2 col-form-label">Equipment <span className="required text-danger"> *</span></label>
                                    <div className="col-lg-6">
                                        <AsyncSelect
                                            value={this.state.equipment}
                                            defaultOptions
                                            loadOptions={this.getAssignedEquipment}
                                            placeholder="Select Equipment"
                                            onChange={this.handleEquipmentChange}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label htmlFor="equipmentCode" className="col-lg-2 col-form-label">Equipment Code</label>
                                    <div className="col-lg-6">
                                        <input type="text" className="form-control" id="equipmentCode" name="equipmentCode" value={this.state.equipment.equipmentCode || ''} readOnly />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-lg-2 col-form-label">Business Unit <span className="required text-danger"> *</span></label>
                                    <div className="col-lg-6">
                                        <Select
                                            value={this.state.project}
                                            onChange={this.handleProjectChange}
                                            options={this.state.allBusinessUnits}
                                            isDisabled={true}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-lg-2 col-form-label" >Project In-charge <span className="required text-danger"> *</span></label>
                                    <div className="col-lg-6">
                                        <AsyncSelect
                                            value={this.state.projectInCharge}
                                            defaultOptions
                                            loadOptions={this.getAllProjectInCharge.bind(null, this.state.project.projectId)}
                                            placeholder="Select Project In-charge"
                                            onChange={this.handleProjectInChargeChange}
                                            menuPosition="fixed"
                                            isDisabled={true}
                                            filterOptions={option => option}
                                            openMenuOnClick={true}
                                            components={{ SingleValue: UserSingleValue }}
                                            getOptionLabel={(option) => (
                                                <>
                                                    <div className='row'>
                                                        <div>
                                                            {option.avatar !== "" ?
                                                                <img src={`${process.env.REACT_APP_USER_ASSET}${option.fileName}`} className='img-fluid' alt='Approver' style={{ width: "70px" }} />
                                                                :
                                                                <img src={toAbsoluteUrl("/media/users/blank.png")} className='img-fluid' alt='Approver' style={{ width: "70px" }} />
                                                            }
                                                        </div>
                                                        <div style={{ marginLeft: "5px" }}>
                                                            <span className="svg-icon svg-icon-md svg-icon-primary">
                                                                <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} />
                                                                <span> Name: {option.employeeName} </span><br></br>
                                                            </span>
                                                            <span className="svg-icon svg-icon-md svg-icon-danger">
                                                                <SVG src={toAbsoluteUrl("/media/svg/icons/Home/Home.svg")} />
                                                                <span>Designation: {option.designationTitle} </span><br></br>
                                                            </span>
                                                            <span className="svg-icon svg-icon-md svg-icon-warning">
                                                                <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Color-profile.svg")} />
                                                                <span> Work Station: {option.workStationName}</span>
                                                            </span>
                                                        </div>

                                                    </div>

                                                </>
                                            )}

                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-lg-2 col-form-label" >Site Engineer <span className="required text-danger"> *</span></label>
                                    <div className="col-lg-6">
                                        <AsyncSelect
                                            value={this.state.siteEngineer}
                                            defaultOptions
                                            loadOptions={this.getAllSiteEngineer.bind(null, this.state.projectInCharge.inChargeBusinessUnitId)}
                                            placeholder="Select Site Engineer"
                                            onChange={this.handleSiteEngineerChange}
                                            menuPosition="fixed"
                                            isDisabled={!this.state.projectInCharge.inChargeBusinessUnitId ? true : false}
                                            components={{ SingleValue: UserSingleValue }}
                                            getOptionLabel={(option) => (
                                                <>
                                                    <div className='row'>
                                                        <div>
                                                            {option.avatar !== "" ?
                                                                <img src={`${process.env.REACT_APP_USER_ASSET}${option.fileName}`} className='img-fluid' alt='Approver' style={{ width: "70px" }} />
                                                                :
                                                                <img src={toAbsoluteUrl("/media/users/blank.png")} className='img-fluid' alt='Approver' style={{ width: "70px" }} />
                                                            }
                                                        </div>
                                                        <div style={{ marginLeft: "5px" }}>
                                                            <span className="svg-icon svg-icon-md svg-icon-primary">
                                                                <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} />
                                                                <span> Name: {option.employeeName} </span><br></br>
                                                            </span>
                                                            <span className="svg-icon svg-icon-md svg-icon-danger">
                                                                <SVG src={toAbsoluteUrl("/media/svg/icons/Home/Home.svg")} />
                                                                <span>Designation: {option.designationTitle} </span><br></br>
                                                            </span>
                                                            <span className="svg-icon svg-icon-md svg-icon-warning">
                                                                <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Color-profile.svg")} />
                                                                <span> Work Station: {option.workStationName}</span>
                                                            </span>
                                                        </div>

                                                    </div>

                                                </>
                                            )}

                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label htmlFor="assignDate" className="col-lg-2 col-form-label">Assign Date<span className="required text-danger"> *</span></label>
                                    <div className="col-lg-6">
                                        <input className="form-control form-control-md" type="date" name="assignDate" id="assignDate" value={this.state.assignDate} onChange={this.handleInputOnChange} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label htmlFor="remarks" className="col-lg-2 col-form-label">Remarks</label>
                                    <div className="col-lg-6">
                                        <textarea className="form-control" id="remarks" name="remarks" value={this.state.remarks} onChange={this.handleInputOnChange} />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="card-footer">
                            <div className="row">
                                <div className="col-4">
                                </div>
                                <div className="col-6">
                                    <button type="submit" className="btn btn-success mr-2">Submit</button>
                                    <button type="reset" className="btn btn-secondary">Cancel</button>
                                </div>
                            </div>
                        </div>

                        {/* <pre>
							{JSON.stringify(this.state, null, 2)}
						</pre> */}
                    </form>

                </div>

                {/* <ToastContainer /> */}
            </>
        );
    }
}

export default EquipmentSiteEngineerAssign;